import { render } from "./NewProjectView.vue?vue&type=template&id=0e909fee"
import script from "./NewProjectView.vue?vue&type=script&lang=js"
export * from "./NewProjectView.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__